import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VAutocomplete,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  transitions,
  VCard,
  VTooltip,
  VBadge,
  VSubheader,
  VBottomNav,
  VSpeedDial,
  VAvatar,
  VDivider,
  VChip,
  VImg,
  VTextField,
  VStepper,
  VExpansionPanel,
  VMenu,
  VBottomSheet,
  VDialog,
  VSlider,
  VRadioGroup,
  VSwitch,
  VDatePicker,
  VSelect,
  VCheckbox,
  VTabs,
  VTimePicker,
  VWindow,
  VSnackbar,
  VAlert,
  VProgressLinear,
  VTextarea,
  VHover,
  VParallax,
  VPagination

} from 'vuetify'
import 'vuetify/src/stylus/app.styl'
import { Ripple, Resize, Touch } from 'vuetify/es5/directives'
import IconChartBubble from '@/components/global_comps/Icons/IconChartBubble.vue'
import IconBalloon from '@/components/global_comps/Icons/IconBalloon.vue'
import IconBirthdayCake from '@/components/global_comps/Icons/IconBirthdayCake.vue'

Vue.use(Vuetify, {
  icons: {
    chartbubble: {
      component: IconChartBubble,
    },
    balloon: {
      component: IconBalloon,
    },
    birthdaycake: {
      component: IconBirthdayCake,
    },

  },
  components: {
    VApp,
    VNavigationDrawer,
    VAutocomplete,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    Vuetify,
    VCard,
    VTooltip,
    VBadge,
    VSubheader,
    VBottomNav,
    VSpeedDial,
    VAvatar,
    VDivider,
    VChip,
    VImg,
    VTextField,
    VStepper,
    VExpansionPanel,
    VMenu,
    VBottomSheet,
    VDialog,
    VSlider,
    VRadioGroup,
    VSwitch,
    VDatePicker,
    VSelect,
    VCheckbox,
    VTabs,
    VTimePicker,
    VWindow,
    VSnackbar,
    VAlert,
    VProgressLinear,
    VTextarea,
    VParallax,
    VHover,
    VPagination
  },
  directives: {
    Ripple,
    Resize,
    Touch
  },
  // theme: {
  //   primary: '#78909C',
  //   secondary: '#CFD8DC',
  //   accent: '#757575',
  //   error: '#D84315',
  //   warning: '#ffeb3b',
  //   info: '#2196f3',
  //   success: '#4caf50'
  // }
  // Standard:
  theme: {
    primary: '#78909C',
    secondary: '#546E7A',
    accent: '#CFD8DC',
    error: '#F44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#4caf50'
  },

})
